import { AccountRemoveOutlineIcon } from './AccountRemoveOutlineIcon';

/**
 * author: Austin Andrews
 * id 9F89EDE8-E95A-401D-9532-7F0DCD6AE321
 * name account-remove-outline
 * version: 2.8.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/account-remove-outline.svg
 * tags
 * - Account / User 
 */
export const UserRemoveOutlineIcon = AccountRemoveOutlineIcon;
export default UserRemoveOutlineIcon